import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../Images";
import { Link, useLocation } from "react-router-dom";

import ContactDetailsModal from "./ContactDetailModel";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { FaQuestionCircle } from "react-icons/fa";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";


const Navbar = () => {
  const [isNavActive, setIsNavActive] = useState(false);
  const { t, i18n } = useTranslation();
  const [openContactModel, setOpenContactModel] = useState(false);
  const { pathname } = useLocation();
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [selectedLang, setActiveLang] = useState("eng");

  const dispatch = useDispatch();

  const languageChangeHandler = (value) => {
    setActiveLang(value);
    i18n.changeLanguage(value);
  };

  //console.log("user", user);
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
  }, [window.innerWidth]);

  useEffect(() => {
    setIsNavActive(false);
  }, [pathname]);

  const toggleNavbar = () => setIsNavActive(!isNavActive);

  return (
    <>
      {openContactModel && (
        <ContactDetailsModal setOpenContactModel={setOpenContactModel} />
      )}

      <Nav>
        <Container $isNavActive={isNavActive}>

          {/* <MenuIconComp toggleNavbar={toggleNavbar} /> */}
          <NavLinksComp
            isNavActive={isNavActive}
            setOpenContactModel={setOpenContactModel}
            setShowHelpPopup={setShowHelpPopup}
            showHelpPopup={showHelpPopup}
            languageChangeHandler={languageChangeHandler}
            selectedLang={selectedLang}
          />
        </Container>
      </Nav>
    </>
  );
};

const NavLinksComp = ({
  isNavActive,
  selectedLang,
  setShowHelpPopup,
  setOpenContactModel,
  languageChangeHandler
}) => {

  const { t, i18n } = useTranslation();

  return (
    <NavLinksWrapper>
        <NavLink>
        <InlineBtn onClick={() => setOpenContactModel(true)}>{t("Contact")}</InlineBtn>
        </NavLink>
      <NavLink>
        <Select
          className="w-28 h-10 pl-2 b-0 text-sm text-slate-700"
          value={selectedLang}
          //sx={{ '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
          onChange={(e) => {
            console.log(e.target.value);
            languageChangeHandler(e.target.value);
          }}
        >
          <MenuItem value="eng">English</MenuItem>
          <MenuItem value="swahili">Swahili</MenuItem>
        </Select>
      </NavLink>
    </NavLinksWrapper>
  );
};

const Nav = tw.nav`z-40 bg-white w-full navbar fixed top-0 right-0 left-0`;

const MenuIcon = tw.div`cursor-pointer z-10 md:hidden`;

const Container = tw.div` 
Container flex items-center justify-between`;

const Logo = tw.img`w-12 z-10 h-14`;
const VerticalBorder = tw.div`w-2.5 h-12 bg-gray-300 mt-1`;

const Button = tw.button` mt-10 h-20 w-96  md:w-72 lg:w-96 px-5   text-gray-800 flex items-center border rounded-md bg-white z-10 loginBtn  `;

const NavLinksWrapper = tw.ul`
fixed  shadow-md top-0 right-0 left-0 flex flex-col bg-white pt-20 transition duration-200 pb-5  relative  translate-y-0 shadow-none flex-row bg-transparent p-0   items-center w-full justify-end h-full`;

// const NavLink = tw.li`
// ${(p) => (p.$last ? "" : "border-b")}
// text-sm text-gray-500 hover:text-gray-800 relative hover:bg-gray-100 flex space-x-1.5 items-center cursor-pointer w-full   py-3 nav-links-padding  md:hover:bg-transparent md:p-0 md:bg-tranparent  md:border-transparent  md:border-b-2 hover:border-gray-400  whitespace-nowrap md:w-auto md:h-full `;

const NavLink = tw.li`text-sm text-gray-500 relative flex space-x-1.5 items-center cursor-pointer w-full py-3 px-4 h-9 rounded-full  whitespace-nowrap md:w-auto md:h-full ml-1 `;

const NavLinkDropdown = tw.li` 
${(p) => (p.$active ? "md:bg-gray-100 text-gray-900" : "")}
text-sm text-gray-500  hover:text-gray-900 relative flex space-x-1.5 items-center cursor-pointer w-full   py-3    px-4 h-9 rounded-full whitespace-nowrap md:w-auto md:h-full ml-1 `;

const SubLinksWrapper = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-3 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform  translate-y-full  -translate-x-4`;

const SubLinksWrapper2 = tw.div`flex flex-col absolute bottom-0 bg-white p-2 py-3 text-sm  rounded-md border border-gray-200 shadow-md z-10 transform translate-y-full -translate-x-0 w-36`;
const HelpIcon = tw(FaQuestionCircle)`
  text-blue-500 text-xl cursor-pointer
`;

export const InlineBtn = tw.button`
text-sm  w-32  md:w-32 h-10 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed border-[1px] text-slate-700 rounded border-slate-400`;

const HelpPopup = ({ onClose }) => (
  <div>
    <p>Email: example@example.com</p>
    <p>Phone: +1 234 567 890</p>
    <button onClick={onClose}>Close</button>
  </div>
);
export default Navbar;
